import { ReactNode } from "react"
import { Link, NavLink, Outlet } from "react-router-dom"
import NavBar from "../components/NavBar";
//import SideBar from "../components/SideBar";

type Props = {
  children?: ReactNode
}

function Layout({ children }: Props) {
  return (
    <div className="bg-black">
      <main className="flex flex-col items-center">
          <NavBar />
        <div className="w-screen h-fit">
          <Outlet />
        </div>
      </main>
    </div>
  );
}

export default Layout;
